export default {
  toasts: {
    load_error: 'No se pudieron cargar las facturas.',
    action_error: 'La acción falló — inténtalo de nuevo.',
    finalized: 'Factura finalizada.',
    marked_paid: 'Factura marcada como pagada.',
  },
  filters: {
    status: 'Filtrar por estado',
  },
  volume_discount_badge: 'Descuento por volumen aplicado ({{licenses}} licencias, {{percent}}%)',
  columns: {
    description: 'Factura',
    status: 'Estado',
    total: 'Total',
    paid_at: 'Pagado el',
  },
  statuses: {
    pending: 'Pendiente',
    processing: 'Procesando',
    paid: 'Pagado',
    failed: 'Fallido',
    refunded: 'Reembolsado',
    partially_refunded: 'Parcialmente reembolsado',
  },
  companies: {
    partner_level: 'Ajustes a nivel de partner',
    columns: {
      company: 'Restaurante',
      buckets: 'Posiciones',
      amount: 'Importe',
    },
  },
  buckets: {
    license_fees: 'Cuotas de licencia',
    service_fees: 'Cuotas de servicio',
    processing_fees: 'Cuotas de procesamiento',
    delivery_fees: 'Cuotas de entrega',
    gift_card_fees: 'Cuotas de tarjeta regalo',
    adjustments: 'Ajustes',
  },
  entries: {
    count: '{{count}} entradas',
    columns: {
      description: 'Entrada',
      occurred_at: 'Fecha',
      amount: 'Importe',
    },
  },
  incl_tax: 'incl. {{amount}} IVA',
  actions: {
    open_invoice_pdf: 'Descargar factura (PDF)',
    open_hosted: 'Abrir factura en Stripe',
    export_csv: 'Exportar CSV',
    finalize: 'Finalizar en Stripe',
    mark_paid: 'Marcar como pagada',
  },
  finalize: {
    title: '¿Finalizar esta factura en Stripe?',
    description:
      'Al finalizar se inicia el cobro: con un método de pago guardado el cargo se realiza automáticamente; de lo contrario el socio recibe la factura alojada.',
    confirm: 'Finalizar',
  },
  mark_paid: {
    pushed_note:
      'Esta factura ya está en Stripe — el borrador se eliminará (o una factura finalizada se marcará como pagada fuera de banda) para que Stripe deje de cobrar.',
    title: '¿Marcar esta factura como pagada?',
    description:
      'Registra un pago manual (offline) de {{amount}}. Úsalo para transferencias bancarias cobradas fuera de Stripe.',
    confirm: 'Marcar como pagada',
  },
  settlement_badge: {
    paid: 'Reparto de ingresos pagado: {{amount}}',
    other: 'Pago de reparto de ingresos {{amount}} · {{status}}',
  },
  settlements: {
    title: 'Pagos de reparto de ingresos',
    retry: 'Reintentar',
    toasts: {
      load_error: 'No se pudieron cargar los pagos.',
      retry_error: 'El reintento falló. Inténtalo de nuevo.',
      retry_paid: 'Reparto de ingresos pagado.',
      retry_attempted: 'Reintento ejecutado; el pago aún no se ha completado, comprueba su estado.',
    },
    columns: {
      period: 'Periodo',
      amount: 'Importe',
      status: 'Estado',
      transfer: 'Transferencia',
      paid_at: 'Pagado el',
      payout: 'Pago',
    },
    payout: {
      direct: '{{amount}}, sin conversión',
      direct_tooltip:
        'Se debe {{owed}}, convertido a 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}} y enviado tal cual: sin conversión de Stripe, sin comisión.',
      converted: 'Enviado {{sent}} → recibido {{arrived}}',
      expected: 'Enviado {{sent}} → esperado {{arrived}}',
      fee: 'Comisión de conversión de Stripe {{amount}}',
      net: 'neto {{amount}}',
      pending_details: 'La comisión y el neto aparecen cuando Stripe liquida la transferencia.',
      tooltip:
        'Adeudado {{owed}}. Convertido a 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}}, enviado desde el saldo de la plataforma en {{source_currency}}, y convertido por Stripe a 1 {{source_currency}} = {{stripe_rate}} {{payout_currency}}. Stripe deduce {{fee_rate}}% al llegar.',
    },
    statuses: {
      pending: 'Pendiente',
      held: 'Retenido',
      processing: 'Procesando',
      paid: 'Pagado',
      failed: 'Fallido',
      reversed: 'Revertido',
    },
    hold_reasons: {
      kyc_incomplete: 'El partner aún no ha completado la verificación de la cuenta de pagos.',
      transfers_inactive: 'La cuenta de pagos todavía no puede recibir transferencias.',
      insufficient_platform_balance: 'El saldo de la plataforma no puede cubrir este pago ahora mismo.',
      manual_hold: 'Retenido manualmente.',
      missing_fx_rate: 'Aún no hay un tipo de cambio guardado para la moneda de pago. Se reintenta automáticamente.',
      unsupported_payout_currency:
        'Stripe no puede pagar esto en la moneda de la cuenta de pago desde el saldo de la plataforma.',
      amount_too_small: 'El importe adeudado está por debajo del mínimo de transferencia de Stripe para esta moneda.',
    },
  },
};
